import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import $ from 'jquery';
import progress from './ui/react-ui/progress.jsx';
import Tabs from './ui/react-ui/tabs';
import DateRange from './ui/react-ui/date-range';
import StatsDashboardInfo from './statsDashboard/statsDashboard-info'; // import StatsDashboardLog from './statsDashboard/statsDashboard-log'

import StatsDashboardGatesLog from './statsDashboard/statsDashboard-gates-log';
import StatsDashboardTerminalsLog from './statsDashboard/statsDashboard-terminals-log'; // api

import { getStatsZones, getStatsGates, getLogsGates, getStatsTerminals, getStatsTerminalsDelivery, getLogsTerminals } from '../api/statsAPI'; // redux

import { setIsDateTimeChange, setStatsZones, setStatsGatesForPie, setStatsGatesForXY, setStatsTerminalsForPie, setStatsTerminalsForXY, setStatsTerminalsDelivery, setLogsGates, setLogsTerminals, setZonesList, setTerminalsList, setLogsTerminalsTotal, setLogsGatesTotal, setDateTime, reset } from '../redux/stats-dashboard';
var t = i18n.getFixedT(null, 'stats-dashboard');
var gt = i18n.getFixedT(null, 'app');
var StatsDashboard = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      rights = _useSelector.sessionObj.rights,
      _useSelector$envCfg = _useSelector.envCfg,
      contextRoot = _useSelector$envCfg.contextRoot,
      isManagementMode = _useSelector$envCfg.isManagementMode,
      _useSelector$statsDas = _useSelector.statsDashboard,
      isDateTimeChange = _useSelector$statsDas.isDateTimeChange,
      dateTime = _useSelector$statsDas.dateTime,
      statsGatesPieSelected = _useSelector$statsDas.statsGatesPieSelected,
      statsGatesXYSelected = _useSelector$statsDas.statsGatesXYSelected,
      gatesSort = _useSelector$statsDas.gatesSort,
      statsTerminalsPieSelected = _useSelector$statsDas.statsTerminalsPieSelected,
      statsTerminalsXYSelected = _useSelector$statsDas.statsTerminalsXYSelected,
      terminalsXYZonesSelected = _useSelector$statsDas.terminalsXYZonesSelected,
      terminalsXYTerminalsSelected = _useSelector$statsDas.terminalsXYTerminalsSelected,
      terminalsSort = _useSelector$statsDas.terminalsSort,
      logsGatesSelected = _useSelector$statsDas.logsGatesSelected,
      logsTerminalsSelected = _useSelector$statsDas.logsTerminalsSelected,
      logsTerminalsRowsPerPage = _useSelector$statsDas.logsTerminalsRowsPerPage,
      logsTerminalsCurrentPage = _useSelector$statsDas.logsTerminalsCurrentPage,
      logsGatesRowsPerPage = _useSelector$statsDas.logsGatesRowsPerPage,
      logsGatesCurrentPage = _useSelector$statsDas.logsGatesCurrentPage;

  var dispatch = useDispatch();
  var rightGate = isManagementMode ? 'evms.dashboard.performance.gate' : 'web.dashboard.performance.gate';
  var rightTerminal = isManagementMode ? 'evms.dashboard.performance.terminal' : 'web.dashboard.performance.terminal';
  var hasLeastOneTab = _.includes(rights, rightGate) || _.includes(rights, rightTerminal) ? true : false;
  if (!hasLeastOneTab) return null;
  var initTabSelected = _.includes(rights, rightGate) ? 'gate' : 'terminal';
  var id = props.id;

  var _useState = useState(initTabSelected),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var mounted = useRef(); // const isChange = useRef(true)
  // const beforeDateTime = useRef()
  // set tab menu

  var tabsMenu = [];
  if (_.includes(rights, rightGate)) tabsMenu.push({
    key: 'gate',
    title: t('lbl-gate-station')
  });
  if (_.includes(rights, rightTerminal)) tabsMenu.push({
    key: 'terminal',
    title: t('lbl-terminal-station')
  });
  var initDateTime = {
    from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
    to: moment().format('YYYY-MM-DD HH:mm')
  };

  var fetchGatesData = function fetchGatesData() {
    var dateRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initDateTime;
    var isShowProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    isShowProgress && progress.startSpin();
    var statsZones, statsGates_pie, statsGates_xy, logsGates;
    statsZones = getStatsZones(contextRoot, true, dateRange);
    statsGates_pie = getStatsGates(contextRoot, true, statsGatesPieSelected, dateRange);
    statsGates_xy = getStatsGates(contextRoot, true, statsGatesXYSelected, dateRange);
    var offset = (Number(logsGatesCurrentPage + 1) - 1) * logsGatesRowsPerPage;
    logsGates = getLogsGates(contextRoot, true, logsGatesSelected, dateRange, gatesSort, offset, logsGatesRowsPerPage);
    $.when(statsZones, statsGates_pie, statsGates_xy, logsGates).then(function (dataZones, dataGatesPie, dataGatesXy, dataLogsGates) {
      dispatch(setStatsZones(_.isEmpty(dataZones.content) ? 'noData' : dataZones.content));
      dispatch(setStatsGatesForPie(_.isEmpty(dataGatesPie.content) ? 'noData' : dataGatesPie.content));
      dispatch(setStatsGatesForXY(_.isEmpty([dataGatesXy.content]) ? 'noData' : dataGatesXy.content));

      var newDataLogsGates = _.map(dataLogsGates.content, function (el, index) {
        return _objectSpread(_objectSpread({}, el), {}, {
          sequence: offset + index + 1
        });
      });

      dispatch(setLogsGates(newDataLogsGates));
      dispatch(setLogsGatesTotal(dataLogsGates.totalElements));
      isShowProgress && progress.done();
    }).catch(function (error) {
      console.log(error);
      progress.done();
    });
  };

  var fetchTerminalsData = function fetchTerminalsData() {
    var dateRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initDateTime;
    var isShowProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    isShowProgress && progress.startSpin();
    var statsTerminals_pie, statsTerminals_xy, statsTerminalsDelivery, logsTerminals;
    statsTerminals_pie = getStatsTerminals(contextRoot, true, statsTerminalsPieSelected, dateRange);
    statsTerminals_xy = getStatsTerminals(contextRoot, true, statsTerminalsXYSelected, dateRange);
    statsTerminalsDelivery = getStatsTerminalsDelivery(contextRoot, true, terminalsXYZonesSelected, terminalsXYTerminalsSelected, dateRange);
    var offset = (Number(logsTerminalsCurrentPage + 1) - 1) * logsTerminalsRowsPerPage;
    logsTerminals = getLogsTerminals(contextRoot, true, logsTerminalsSelected, dateRange, terminalsSort, offset, logsTerminalsRowsPerPage);
    $.when(statsTerminals_pie, statsTerminals_xy, statsTerminalsDelivery, logsTerminals).then(function (dataTerminalsPie, dataTerminalsXy, dataTerminalsDelivery, logsTerminals) {
      dispatch(setStatsTerminalsForPie(_.isEmpty(dataTerminalsPie.content) ? 'noData' : dataTerminalsPie.content));
      dispatch(setStatsTerminalsForXY(_.isEmpty(dataTerminalsXy.content) ? 'noData' : dataTerminalsXy.content));
      dispatch(setStatsTerminalsDelivery(_.isEmpty(dataTerminalsDelivery.content) ? 'noData' : dataTerminalsDelivery.content));

      var newLogsTerminals = _.map(logsTerminals.content, function (el, index) {
        return _objectSpread(_objectSpread({}, el), {}, {
          sequence: offset + index + 1
        });
      });

      dispatch(setLogsTerminals(newLogsTerminals));
      dispatch(setLogsTerminalsTotal(logsTerminals.totalElements));
      isShowProgress && progress.done();
    }).catch(function (error) {
      console.log(error);
      progress.done();
    });
  };

  var handleFetch = function handleFetch() {
    if (currentTab === 'gate') fetchGatesData(dateTime, true);else fetchTerminalsData(dateTime, true);
  };

  var handleChangeDateTime = function handleChangeDateTime(dateTime) {
    dispatch(setDateTime(dateTime));
  }; // const handleCloseDateRange = value => {
  //     if(_.isEqual(beforeDateTime.current, value))
  //         return
  //     dispatch(setIsDateTimeChange(!isChange.current))
  // }


  var initFetchData = function initFetchData() {
    // beforeDateTime.current = initDateTime
    dispatch(setDateTime(initDateTime));
    if (initTabSelected === 'gate') fetchGatesData(initDateTime, true);else fetchTerminalsData(initDateTime, true);
  };

  useEffect(function () {
    if (!mounted.current) return;
    handleFetch();

    if (currentTab === 'gate') {
      dispatch(setStatsTerminalsForPie([]));
      dispatch(setStatsTerminalsForXY([]));
      dispatch(setStatsTerminalsDelivery([]));
    } else {
      dispatch(setStatsZones([]));
      dispatch(setStatsGatesForPie([]));
      dispatch(setStatsGatesForXY([]));
    }
  }, [currentTab]); // useEffect(() => {
  //     if(!mounted.current)
  //         return
  //     isChange.current = isDateTimeChange
  //     beforeDateTime.current = dateTime
  //     // handleFetch()
  // }, [isDateTimeChange])

  useEffect(function () {
    if (!mounted.current) {
      initFetchData();
      mounted.current = true;
    }

    return function () {
      dispatch(reset());
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "statsDashboard-headBar"
  }, /*#__PURE__*/React.createElement(DateRange, {
    id: "datetime",
    enableTime: true,
    enableStartEndLabel: true,
    startLabel: t('lbl-start-time'),
    endLabel: t('lbl-end-time') // allowKeyIn={false}
    ,
    onChange: handleChangeDateTime // onClose={handleCloseDateRange}
    ,
    defaultValue: initDateTime,
    value: dateTime,
    limitRange: '30d' // t={(code, params) => {
    //     if (code === 'missing')
    //         return `Please input date`
    //     else {
    //         return `Invalid date format. Should be ${params.pattern}`
    //     }
    // }}

  }), /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: function onClick() {
      return handleFetch();
    }
  }, gt('global.lbl-search'))), /*#__PURE__*/React.createElement(Tabs, {
    id: "g-stats-dashboard-tabs",
    menu: tabsMenu,
    current: currentTab,
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-content"
  }, /*#__PURE__*/React.createElement(StatsDashboardInfo, {
    currentTab: currentTab
  }), currentTab === 'gate' ? /*#__PURE__*/React.createElement(StatsDashboardGatesLog, null) : /*#__PURE__*/React.createElement(StatsDashboardTerminalsLog, null))));
});
StatsDashboard.defaultProps = {
  id: 'g-stats-dashboard'
};
StatsDashboard.PropTypes = {
  id: PropTypes.string
};
export default StatsDashboard;